import makeActionCreator from 'utils/makeActionCreator'
import actions from 'scenes/Home/actions'

export const types = {
  ADD_PROJECT_JURISDICTION_REQUEST: 'ADD_PROJECT_JURISDICTION_REQUEST',
  ADD_PROJECT_JURISDICTION_SUCCESS: 'ADD_PROJECT_JURISDICTION_SUCCESS',
  ADD_PROJECT_JURISDICTION_FAIL: 'ADD_PROJECT_JURISDICTION_FAIL',
  UPDATE_PROJECT_JURISDICTION_REQUEST: 'UPDATE_PROJECT_JURISDICTION_REQUEST',
  UPDATE_PROJECT_JURISDICTION_SUCCESS: 'UPDATE_PROJECT_JURISDICTION_SUCCESS',
  UPDATE_PROJECT_JURISDICTION_FAIL: 'UPDATE_PROJECT_JURISDICTION_FAIL',
  GET_PROJECT_JURISDICTIONS_REQUEST: 'GET_PROJECT_JURISDICTIONS_REQUEST',
  GET_PROJECT_JURISDICTIONS_SUCCESS: 'GET_PROJECT_JURISDICTIONS_SUCCESS',
  GET_PROJECT_JURISDICTION_FAIL: 'GET_PROJECT_JURISDICTION_FAIL',
  UPDATE_JURISDICTION_SEARCH_VALUE: 'UPDATE_JURISDICTION_SEARCH_VALUE',
  SEARCH_JURISDICTION_LIST: 'SEARCH_JURISDICTION_LIST',
  SET_JURISDICTION_SUGGESTIONS: 'SET_JURISDICTION_SUGGESTIONS',
  UPDATE_SUGGESTION_VALUE: 'UPDATE_SUGGESTION_VALUE',
  ON_CLEAR_SUGGESTIONS: 'ON_CLEAR_SUGGESTIONS',
  CLEAR_JURISDICTIONS: 'CLEAR_JURISDICTIONS',
  ON_JURISDICTION_SELECTED: 'ON_JURISDICTION_SELECTED',
  ADD_JURISDICTION_TO_PROJECT: 'ADD_JURISDICTION_TO_PROJECT',
  UPDATE_JURISDICTION_IN_PROJECT: 'UPDATE_JURISDICTION_IN_PROJECT',
  RESET_FORM_ERROR: 'RESET_FORM_ERROR',
  UPDATE_EDITED_FIELDS: 'UPDATE_EDITED_FIELDS',
  ADD_PRESET_JURISDICTION_REQUEST: 'ADD_PRESET_JURISDICTION_REQUEST',
  ADD_PRESET_JURISDICTION_SUCCESS: 'ADD_PRESET_JURISDICTION_SUCCESS',
  ADD_PRESET_JURISDICTION_FAIL: 'ADD_PRESET_JURISDICTION_FAIL',
  ADD_PRESET_JURISDICTION_TO_PROJECT: 'ADD_PRESET_JURISDICTION_TO_PROJECT',
  DELETE_JURISDICTION_REQUEST: 'DELETE_JURISDICTION_REQUEST',
  DELETE_JURISDICTION_SUCCESS: 'DELETE_JURISDICTION_SUCCESS',
  DELETE_JURISDICTION_FAIL: 'DELETE_JURISDICTION_FAIL',
  DELETE_JURISDICTION_FROM_PROJECT: 'DELETE_JURISDICTION_FROM_PROJECT',
  SHOW_JURISDICTION_LOADER: 'SHOW_JURISDICTION_LOADER',
  INITIALIZE_FORM: 'INITIALIZE_FORM',
  RESET_FORM_VALUES: 'RESET_FORM_VALUES',
  SET_FORM_VALUES: 'SET_FORM_VALUES',
  DISMISS_DELETE_ERROR_ALERT: 'DISMISS_DELETE_ERROR_ALERT'
}

export default {
  addJurisdiction: makeActionCreator(types.ADD_PROJECT_JURISDICTION_REQUEST, 'jurisdiction', 'projectId'),
  updateJurisdiction: makeActionCreator(types.UPDATE_PROJECT_JURISDICTION_REQUEST, 'jurisdiction', 'projectId', 'projectJurisdictionId'),
  addPresetJurisdictionRequest: makeActionCreator(types.ADD_PRESET_JURISDICTION_REQUEST, 'jurisdiction', 'projectId'),
  getProjectJurisdictions: makeActionCreator(types.GET_PROJECT_JURISDICTIONS_REQUEST, 'projectId'),
  updateSearchValue: makeActionCreator(types.UPDATE_JURISDICTION_SEARCH_VALUE, 'searchValue'),
  clearJurisdictions: makeActionCreator(types.CLEAR_JURISDICTIONS),
  searchJurisdictionList: makeActionCreator(types.SEARCH_JURISDICTION_LIST, 'searchString'),
  onSuggestionValueChanged: makeActionCreator(types.UPDATE_SUGGESTION_VALUE, 'suggestionValue'),
  onClearSuggestions: makeActionCreator(types.ON_CLEAR_SUGGESTIONS),
  onJurisdictionSelected: makeActionCreator(types.ON_JURISDICTION_SELECTED, 'jurisdiction'),
  addJurisdictionToProject: makeActionCreator(types.ADD_JURISDICTION_TO_PROJECT, 'jurisdiction', 'projectId'),
  updateJurisdictionInProject: makeActionCreator(types.UPDATE_JURISDICTION_IN_PROJECT, 'jurisdiction', 'projectId'),
  deleteJurisdictionRequest: makeActionCreator(types.DELETE_JURISDICTION_REQUEST, 'jurisdictionId', 'projectId'),
  resetFormError: makeActionCreator(types.RESET_FORM_ERROR),
  dismissDeleteErrorAlert: makeActionCreator(types.DISMISS_DELETE_ERROR_ALERT),
  showJurisdictionLoader: makeActionCreator(types.SHOW_JURISDICTION_LOADER),
  initializeFormValues: makeActionCreator(types.INITIALIZE_FORM, 'values'),
  resetToInitial: makeActionCreator(types.RESET_FORM_VALUES),
  setFormValues: makeActionCreator(types.SET_FORM_VALUES, 'prop', 'value'),
  updateEditedFields: actions.updateEditedFields
}
